<template>
  <div class="coupon-wrapper">
    <div>{{ $t("message.offer.showCouponInShop") }}</div>
    <div class="coupon-main-text">{{ couponCode }}</div>
    <div v-if="hasSchedule">
      <span>{{ $t("message.offer.offerValid") }}: </span>
      <span>{{ displayDate }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "PostsPreviewCouponCode",
  props: {
    couponCode: {
      type: String,
      required: true
    },
    hasSchedule: {
      type: Boolean,
      required: true
    },
    displayDate: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.coupon-wrapper {
  background: lighten($gray-200, 5%);
  border: dashed 2px $gray-200;
  padding: $spacing * 2;
  text-align: center;

  .coupon-main-text {
    @include font-size(24px);
    font-weight: 700;
    padding: $spacing * 2 0;
    color: $grey-darker;
  }
}
</style>
